import { useQuery } from "@apollo/client";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@pmberjaya/cloudbank-ui";
import React from "react";
import { Accordion } from "react-bootstrap";
import { HOSTING_PACKAGES } from "../../../gql/hosting";
import { VPS_PACKAGES } from "../../../gql/vps";
import { NumberFormat } from "../../../utils/CurrencyFormat";
import ErrorMessage from "../../Common/ErrorMessage";
import Section from "../../Common/Section";
const HeadTable = () => {
  return (
    <TableHead className="text-center">
      <TableRow>
        <TableCell rowSpan={2}>
          <Typography variant="h5">Nama Paket</Typography>
        </TableCell>
        <TableCell rowSpan={2}>
          <Typography variant="h5">Harga Normal / Bulan</Typography>
        </TableCell>
        <TableCell colspan={3}>
          <Typography variant="h5">Harga Reseller / Bulan</Typography>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Typography variant="h5">Basic</Typography>
        </TableCell>
        <TableCell>
          <Typography variant="h5">Intermediate</Typography>
        </TableCell>
        <TableCell>
          <Typography variant="h5">Pro</Typography>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
const TablePriceReseller = () => {
  const {
    loading,
    error,
    data: hosting,
  } = useQuery(HOSTING_PACKAGES, {
    variables: { limit: 10, page: 1 },
  });
  const {
    loading: loadingVps,
    error: errorVps,
    data: vps,
  } = useQuery(VPS_PACKAGES);
  if (loading) return "loading...";
  if (error) return <ErrorMessage message={"Error"} />;
  if (loadingVps) return "loading...";
  if (errorVps) return <ErrorMessage message={"Error"} />;
  const dataHosting = hosting.hosting.packages.nodes;
  const dataVps = vps.proxmox.packages.nodes.filter(
    (item) => item.name !== "CloudCustom"
  );
  return (
    <Section>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Button className="bg-primary ">
            <Typography variant="h4" color="light">
              Cloud Hosting
            </Typography>
          </Accordion.Button>
          <Accordion.Body className="table-responsive">
            <Table border>
              <HeadTable />
              <TableBody>
                {dataHosting?.map((row) => (
                  <TableRow>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>
                      <NumberFormat
                        value={
                          row.hosting_package_pricing[0].price /
                          row.hosting_package_pricing[0].duration
                        }
                      />
                    </TableCell>
                    <TableCell>
                      {row.hosting_package_pricing[0].reseller_package_pricing
                        .length < 1 ? (
                        "TBA"
                      ) : (
                        <NumberFormat
                          value={
                            row.hosting_package_pricing[0].reseller_package_pricing.filter(
                              (item) => item.reseller_level === 1
                            )[0].reseller_price /
                            row.hosting_package_pricing[0].duration
                          }
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      {row.hosting_package_pricing[0].reseller_package_pricing
                        .length < 1 ? (
                        "TBA"
                      ) : (
                        <NumberFormat
                          value={
                            row.hosting_package_pricing[0].reseller_package_pricing.filter(
                              (item) => item.reseller_level === 2
                            )[0].reseller_price /
                            row.hosting_package_pricing[0].duration
                          }
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      {row.hosting_package_pricing[0].reseller_package_pricing
                        .length < 1 ? (
                        "TBA"
                      ) : (
                        <NumberFormat
                          value={
                            row.hosting_package_pricing[0].reseller_package_pricing.filter(
                              (item) => item.reseller_level === 3
                            )[0].reseller_price /
                            row.hosting_package_pricing[0].duration
                          }
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Button className="bg-primary ">
            <Typography variant="h4" color="light">
              Cloud VPS
            </Typography>
          </Accordion.Button>
          <Accordion.Body className="table-responsive">
            <Table border>
              <HeadTable />
              <TableBody>
                {dataVps.map((row) => (
                  <TableRow>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>
                      <NumberFormat
                        value={
                          row.package_pricings[0].price /
                          row.package_pricings[0].duration
                        }
                      />
                    </TableCell>
                    <TableCell>
                      {row.package_pricings[0].reseller_package_pricing.length <
                      1 ? (
                        "TBA"
                      ) : (
                        <NumberFormat
                          value={
                            row.package_pricings[0].reseller_package_pricing.filter(
                              (item) => item.reseller_level === 1
                            )[0]?.reseller_price /
                            row.package_pricings[0].duration
                          }
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      {row.package_pricings[0].reseller_package_pricing.length <
                      1 ? (
                        "TBA"
                      ) : (
                        <NumberFormat
                          value={
                            row.package_pricings[0].reseller_package_pricing.filter(
                              (item) => item.reseller_level === 2
                            )[0]?.reseller_price /
                            row.package_pricings[0].duration
                          }
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      {row.package_pricings[0].reseller_package_pricing.length <
                      1 ? (
                        "TBA"
                      ) : (
                        <NumberFormat
                          value={
                            row.package_pricings[0].reseller_package_pricing.filter(
                              (item) => item.reseller_level === 3
                            )[0]?.reseller_price /
                            row.package_pricings[0].duration
                          }
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Section>
  );
};

export default TablePriceReseller;
